"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emphasizeColor = exports.mb = exports.mediaSizes = void 0;
const polished_1 = require("polished");
exports.mediaSizes = {
    xxs: 320,
    xs: 480,
    s: 600,
    m: 768,
    l: 992,
    xl: 1100,
    xxl: 1200,
    xxxl: 1350,
};
function mb(from) {
    if (typeof from === 'string') {
        if (from in exports.mediaSizes) {
            return `@media (min-width: ${(0, polished_1.rem)(exports.mediaSizes[from])})`;
        }
        else {
            throw new Error(`mb: Media size "${from}" is not defined. Use one of [${Object.keys(exports.mediaSizes)}]`);
        }
    }
    if (typeof from !== 'number') {
        throw new Error(`mb: Invalid media breakpoint argument "${from}"`);
    }
    return `@media (min-width: ${(0, polished_1.rem)(from)})`;
}
exports.mb = mb;
const emphasizeColor = (amount, color, reverse = false) => {
    const isColorDark = (0, polished_1.readableColor)(color, '#fff', '#000', false) === '#000';
    if (isColorDark && reverse) {
        return (0, polished_1.lighten)(amount, color);
    }
    else if (isColorDark) {
        return (0, polished_1.darken)(amount, color);
    }
    else if (!isColorDark && reverse) {
        return (0, polished_1.darken)(amount, color);
    }
    else {
        return (0, polished_1.lighten)(amount, color);
    }
};
exports.emphasizeColor = emphasizeColor;
